import * as React from 'react';
import { CaseInfoForm } from '../components/TransferForm';
import { Row, Label } from 'reactstrap';
import { momentToString } from '../../../../share/utils/utils';
import { WrappedInput } from '../../../../share/components/Input/Input';

export const CaseInfoLayout = (props: { that: CaseInfoForm }) => {
    return <AdvancedLayout {...props} />
}
export const AdvancedLayout = ({ that }) => {
    return (
        <Row className={"margin-forms"}>
            <Country form={that.props.form} />
            <Region form={that.props.form} />
            <City form={that.props.form} />
            <Address form={that.props.form} />
            <Circumstances form={that.props.form} />
            <LastSeen form={that.props.form} />
            <MissingDate form={that.props.form} />
            <CurrentAgency form={that} />
            <NewAgency form={that} />
        </Row>
    )
}

const CurrentAgency = ({ form }) => {
    const currentAgency = form.props.form('agencyCode').value;
    const agencies = form.props.agencies;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">Current Agency:</label> {form.getCurrentAgency(agencies, currentAgency)}</Label>
    )
}

const NewAgency = ({ form }) => {
    return (
        <>
            <Label className="label-name" md={3}>Target agency:</Label>
            <WrappedInput className="transfer-label" id="agencyCode" type="select" {...form.props.form('targetAgency')}
                md={8} disabled={form.props.isEditCase || form.props.disabled} >
                <option value="">Select the new agency</option>
                {form.getAgenciesOptions()}
            </WrappedInput>
        </>
    )
};

const Country = ({ form }) => {
    const country = form('country').value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">Country:</label>{country ? country : 'Unknown'}</Label>
    )
}
const Region = ({ form }) => {
    const state = form('state').value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">State: </label>{state ? state : 'Unknown'}</Label>
    )
}

const City = ({ form }) => {
    const city = form('city').value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">City: </label>{city ? city : 'Unknown'}</Label>
    )
}

const Address = ({ form }) => {
    const address = form('address').value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">Address: </label>{address ? address : 'Unknown'}</Label>
    )
}

const Circumstances = ({ form }) => {
    const circumstances = form('circumstances').value
    return (
        <Label className="transfer-label circumstances-format" md={12}><label className="label-name">Circumstances: </label><br />{circumstances ? circumstances : 'Unknown'}</Label>
    )

}

const MissingDate = ({ form }) => {
    const missingDate = form('missingDate', false).value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">Missing Date: </label>{missingDate ? momentToString(missingDate) : 'Unknown'}</Label>
    )
}
const LastSeen = ({ form }) => {
    const lastSeen = form('lastSeen').value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">Last seen: </label>{lastSeen ? lastSeen : 'Unknown'}</Label>
    )
}



// WEBPACK FOOTER //
// ./src/modules/Case/TransferCase/layouts/TransferInfo.tsx